import { required, email, numeric } from '@vee-validate/rules'; // Adjusted import path for rules
import { defineRule, configure } from 'vee-validate'; // Use `defineRule` and `configure` for rule definitions
import i18n from './i18n.js';

// Set the interaction mode globally
configure({
    generateMessage: (ctx) => {
        const { field, rule, values } = ctx;
        return i18n.t(`VALIDATION.ERROR.${rule.name.toUpperCase()}`, {
            field,
            ...values,
        }).toString();
    },
    validateOnInput: false, // Adjust based on your needs (e.g., lazy validation)
});

// INSTALLED RULES: define rules using `defineRule`
defineRule('required', required);
defineRule('email', email);
defineRule('numeric', numeric);

export const initializeCheckBoxValidator = (language) => {
    defineRule('isTrue', {
        validate: (value) => value === true,  // Custom validation logic for checkbox
        message: i18n.t('VALIDATION.ERROR.MUST_BE_CHECKED', language).toString(),
    });
};
